import React, { useRef, useState, useEffect } from "react";
import { Form, Button, Card, Alert, Container } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import logo from "../../logo-transparente.png"
import { firestore } from "../../firebase";

export default function Login() {
    const emailRef = useRef();
    const passwordRef = useRef();
    const { login, currentUser } = useAuth();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    async function handleSubmit(e) {
        e.preventDefault();
       
        try {
            setError('');
            setLoading(true);

            await login(emailRef.current.value, passwordRef.current.value);

        } catch (error) {
            if (error.code === "auth/invalid-email" || error.code === "auth/wrong-password") {
                setError("Error al iniciar sesión: Correo y/o contraseña incorrectos");
            } else {
                setError("Error inesperado al iniciar sesión");
            }
            setLoading(false);
            return;
        }
    }

    useEffect(() => {

        if (currentUser != null) {
            firestore.collection('usuarios').doc(currentUser.uid).get()
            .then(() => {
                setLoading(false);
                history.push("/");
            })
            .catch(() => {
                setError("No tiene permiso para ingresar al sistema.");
                setLoading(false);
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser]);

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        style = {{ minHeight: "100vh" }}
        >
            <div className="w-100" style = {{ maxWidth: "400px"}}>
                <img className="mx-auto d-block" src={logo} alt="Inventario Provell" style={{ maxHeight: "95px" }}/>
                <br/>
                <Card>
                    <Card.Body>
                        <h2 className="text-center mb-4">Iniciar Sesión</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formGridEmail">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control type="email" ref={emailRef} required/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGridPassword">
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control type="password" ref={passwordRef} required/>
                            </Form.Group>
                            <Button disabled={loading} className="w-100" type="submit">Confirmar</Button>
                        </Form>
                        <div className="w-100 text-center mt-3">
                            <Link to="/forgot-password">Olvidé mi contraseña</Link>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}